import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c522a5fc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c522a5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522a5fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c522a5fc')) {
      api.createRecord('c522a5fc', component.options)
    } else {
      api.reload('c522a5fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c522a5fc&scoped=true&", function () {
      api.rerender('c522a5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/store/storeManager/index.vue"
export default component.exports